import React, { useEffect } from 'react';
import { range } from 'ramda';
import { Select, Stack } from '@moda/om';

type Props = {
  quantity: number;
  quantityAvailable?: number;
  onChange: (quantity: number) => void;
  orderLimit?: number | null;
};

const MAX_QUANTITY = 24;

export const ProductDetailsQuantitySelector: React.FC<Props> = ({
  quantity,
  quantityAvailable = Infinity,
  onChange,
  orderLimit = Infinity
}) => {
  useEffect(() => {
    if (quantity > quantityAvailable) onChange(quantityAvailable);
  }, [quantity, quantityAvailable, onChange]);

  const quantityLimit: number =
    orderLimit != null ? Math.min(orderLimit, quantityAvailable) : quantityAvailable;

  return (
    <Stack space={2} alignItems="flex-start">
      <Select
        label="Qty"
        options={range(1, Math.min(quantityLimit, MAX_QUANTITY) + 1).map(quantity => ({
          label: quantity.toString(),
          value: quantity.toString()
        }))}
        value={quantity.toString()}
        onChange={value => onChange(Number(value))}
      />
    </Stack>
  );
};
